import { NgModule, CUSTOM_ELEMENTS_SCHEMA, LOCALE_ID, ErrorHandler } from '@angular/core';
import { BrowserModule, HammerModule, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { StatusBar } from '@awesome-cordova-plugins/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';

import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/es-CL';
import { IonicGestureConfig } from './core/ionic-gesture-config';
import { Device } from '@awesome-cordova-plugins/device/ngx';
import { RequestCreationGuard } from './core/services/request-creation/request-creation-guard.service';
import { RequirementFormPageModule } from './pages/requirement-form/requirement-form.module';
import { IonicStorageModule } from '@ionic/storage-angular';
// import { FingerprintAIO } from '@awesome-cordova-plugins/fingerprint-aio/ngx';
// import { AppRate } from '@awesome-cordova-plugins/app-rate/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { AtatusErrorHandler } from './atatus.handler';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import localePt from '@angular/common/locales/pt';
import localeEsCl from '@angular/common/locales/es-CL';
import { HttpClient } from '@angular/common/http';

// import { AppTrackingTransparency } from 'capacitor-app-tracking-transparency'

registerLocaleData(localeEsCl, 'es-CL');
registerLocaleData(localePt, 'pt-BR');

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({ swipeBackEnabled: false, innerHTMLTemplatesEnabled: true }),
    AppRoutingModule,
    CoreModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    IonicStorageModule.forRoot(),
    RequirementFormPageModule,
    HammerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  providers: [
    StatusBar,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LOCALE_ID, useValue: "es-CL" },
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: IonicGestureConfig
    },
    Device,
    RequestCreationGuard,
    // FingerprintAIO,
    // AppRate,
    HTTP,
    { provide: ErrorHandler, useClass: AtatusErrorHandler }
    // AppTrackingTransparency
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],

})
export class AppModule { }